import { QueryType } from '~api/features/Default';
import { IQueryTypeFragments } from '~api/QueryFragments';

export const UserLoyaltyInfo = (queryFragments: IQueryTypeFragments) => {
    const userQuery = `{
        user {
            ${queryFragments[QueryType.userInfo]}
            loyalty {
                loyaltyLevelCurrent {
                    ${queryFragments[QueryType.loyaltyLevelCurrent]}
                }
                loyaltyLevelNext {
                    ${queryFragments[QueryType.loyaltyLevelNext]}
                }
            }
        }
        configs {
            loyaltyConfigs {
                current {
                    programVersion
                    tracksSpend
                }
            }
        }
    }`;

    return userQuery;
};
